import React from 'react';
import bgCta from '../../images/wpo-cta-bg-4.jpg'
import icon1 from '../../images/cta/envelope.svg'
import icon2 from '../../images/cta/phone-receiver-silhouette.svg'
import icon3 from '../../images/cta/location-pin.svg'
import icon4 from '../../images/cta/clock.svg'

const CtaSectionS4 = () => {
    return (
        <section className="wpo-cta-section-s4" style={{ backgroundImage: `url(${bgCta})` }}>
            <div className="contact">
                <h3>Get In Touch</h3>
                <ul>
                    <li><img src={icon1} alt="" /> <span>QHB@gmail.com</span></li>
                    <li><img src={icon2} alt="" /> <span>+(208) 555-0112</span>
                    </li>
                    <li><img src={icon3} alt="" /> <span>4517 Washington Ave. Manchter, <br />
                        Kentucky
                        495</span>
                    </li>
                    <li><img src={icon4} alt="" /><span>Mon – Fri: 8am – 9pm <br /> Sat – Sun:
                        Closed</span></li>
                </ul>
            </div>
        </section>
    );
};

export default CtaSectionS4;